module.exports = __webpack_public_path__ + "img/product-s618-4000.49bd49eb.png";